// extracted by mini-css-extract-plugin
module.exports = {"comp":"ListB_comp__Y3DDB"};